<app-modal-header [title]="title"></app-modal-header>
<ion-content class="time-modal-content" *ngIf="isPageReady">
  <app-edit-open-time *ngIf="isOpenTimeRecord; else closeTimeRecord"  (formValuesChanged)="onFormValuesChanged($event)" [userId]="userId" [timeRecordToEdit]="timeRecordToEdit" [interval]="interval"></app-edit-open-time>
  <ng-template #closeTimeRecord>
    <app-edit-closed-time (formValuesChanged)="onFormValuesChanged($event)" [userId]="userId" [timeRecordToEdit]="timeRecordToEdit" [interval]="interval"></app-edit-closed-time>
  </ng-template>
  <app-footer-buttons-spacer></app-footer-buttons-spacer>
</ion-content>
<app-footer-buttons *ngIf="formValues"
[rightButton]="{
  text: 'Save',
  disabled: !formValues.isValid
}"
[leftButton]="{
  icon: 'trash-outline',
  sizing: 'compact'
}"
(rightButtonClicked)="onSave()"
(leftButtonClicked)="onDelete()"
></app-footer-buttons>
